// In case a user alredy has these variables set in cart
(async () => {
  try {
    fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: '{ "attributes": { "x-pa-pacid": "", "x-pa-id": "" } }'
    })
  } catch (error) {
    console.log(error);
  }
})();

async function init() {
  const checkoutForm = document.querySelector(`[action="${theme.routes.cart_url}"]`);
  if (!checkoutForm) return;
  
  let callback = function(mutationsList, observer) {
    for(var mutation of mutationsList) {
        if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1 && node.matches('[name*="x-pa-"]')) {
                  node.remove();
                }
            });
          }
      }
  };
  
  const observer = new MutationObserver(callback);
  const config = { attributes: false, childList: true, subtree: true };
  observer.observe(checkoutForm, config);
  
  // In case it's somehow already loaded
  const paInputs = checkoutForm.querySelectorAll('[name*="x-pa-"]');
  paInputs.forEach(input => input.remove());
}

document.addEventListener('cart-drawer:rendered', () => {
  init();
})